// @flow
import React from 'react';
import {injectIntl} from 'react-intl';
import {SkipToContentMenuProvider} from '@homeaway/react-skip-to-content-menu';

import type {Node} from 'react';
import type {IntlShape} from 'react-intl';

type Props = {
    intl: IntlShape,
    children: Node
};

const ConnectedSkipToContentProvider = (props: Props) => {
    const {formatMessage} = props.intl;
    const skipToContentProps = {
        menuTitle: formatMessage({
            id: 'skipMenuShortCutInstruction',
            defaultMessage: 'To navigate to Skip menu use control + q shortcut.'
        }),
        ariaLabel: formatMessage({
            id: 'skipMenuAriaLabel',
            defaultMessage: 'Skip to content'
        })
    };
    return (
        <SkipToContentMenuProvider {...skipToContentProps}>
            {props.children}
        </SkipToContentMenuProvider>
    );
};

export default injectIntl(ConnectedSkipToContentProvider);
